module.exports = __webpack_public_path__ + "static/media/Introduction_simple.9bf372db.png";